import { TBillingInterval } from "@/types/app";

const BILLING_SUFFIX: Record<TBillingInterval, string> = {
  monthly: "m",
  annual_monthly: "m",
  half_yearly: "6m",
  yearly: "y",
};

/**
 * Short suffix for a billing interval, for use after a price: `m`, `6m` or `y`
 * (as in `$45/m`). Falls back to `na` if the interval is missing at runtime.
 */
export const getBillingLabel = (billingPeriod: TBillingInterval) => {
  if (!billingPeriod) return "na";
  return BILLING_SUFFIX[billingPeriod] ?? "na";
};
